import { render, staticRenderFns } from "./CaseBox.vue?vue&type=template&id=8929f31e&"
import script from "./CaseBox.vue?vue&type=script&lang=js&"
export * from "./CaseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports